export const NUMBER_CONSTS = {
  VISITS_MULTIPLIER: 1000,
  MONTHLY_DIVIDIER: 12,
  BZ_MAX_VALUE: 1750,
  PM_MAX_VALUE: 1250,
}
